/*-----------------------------------------------------------
 The following JavaScript functions control Mandatory Fields
------------------------------------------------------------*/

var TECL_MandatoryFields = {

  // This contains a list of error messages from the last validation run
  LastErrorsList: null,

  // Template to use when displaying an error
  MasterErrorTemplate: "<div class='field-validation-error hidden' data-mandatoryFieldMsg></div>",

  // Validate a container (div/form etc.). If no container is supplied then validate the whole page
  Validate: function (container, keepExsistingErrors, highlight) {

    if (!keepExsistingErrors) {
      // Reset the list of errors
      TECL_MandatoryFields.LastErrorsList = [];
    }

    if (!container) {
      container = $(document);
    } else {
      container = $(container);
    }

    // Clear existing mandatory fields errors
    container.find("[data-mandatoryFieldMsg]").not("[data-htmlTemplate]").remove();

    // Perform validation
    var containerValid = TECL_MandatoryFields.ValidateMandatory(container, highlight);
    if (containerValid) {
      containerValid = TECL_MandatoryFields.ValidateLength(container);
    }
    if (containerValid) {
      containerValid = TECL_MandatoryFields.ValidateCompare(container);
    }

    // Create the summary for this validation run (if there is a summary to create)
    TECL_MandatoryFields.CreateSummary(containerValid, container);

    return containerValid;
  },

  // Validate a container (div/form etc.) for mandatory fields. If no container is supplied then validate the whole page
  ValidateMandatory: function (container, highlight) {

    // Assume the container is valid
    var containerValid = true;

    // Get the template to use for mandatory field error messages
    var mandatoryError = $(TECL_MandatoryFields.MasterErrorTemplate);

    if (mandatoryError && mandatoryError.length > 0) {
      container.find("[data-mandatoryField='true']").each(function () {

        var item = $(this);

        // Get error message and parent here as "item" may change if this is a linked field error
        var errorMessage = item.attr("data-mandatoryError");

        // Check the "item" to see if it is the item that we need to test or whether it is linked to another item
        item = TECL_MandatoryFields.GetItemToValidate(item, container);

        if (item.length > 0) {
          // We have something to validate!
          var groupValid = false;
          item.each(function () {
            // We may have more than one item within the group to validate, so loop through each one and
            // validate it, for validation to pass at least one item must pass
            if ($(this).val() !== "") {
              // Validation succeeded, so the group has succeed 
              groupValid = true;
              return false;
            }
            return true;
          });

          if (!groupValid) {
            if (highlight) {
              // Highlight the field rather than display an error message
              TECL_MandatoryFields.ToggleHiglight(item, true);
            } else {
              // Validation has failed for this group, display the error message
              TECL_MandatoryFields.CreateErrorNode(mandatoryError, item, true, errorMessage);
            }

            // Fail validation for the whole container
            containerValid = false;
          } else {
            if (highlight) {
              TECL_MandatoryFields.ToggleHiglight(item, false);
            }
          }
        }
      });
    }

    return containerValid;
  },

  // Validate any fields that need to be compared to other fields for equality
  ValidateCompare: function (container) {

    // Assume the container is valid
    var containerValid = true;

    // Get the template to use for mandatory field error messages
    var mandatoryError = $(TECL_MandatoryFields.MasterErrorTemplate);

    if (mandatoryError && mandatoryError.length > 0) {
      container.find("[data-mandatoryCompareField='true']").each(function () {

        var item = $(this);
        var errorMessage = item.attr("data-mandatoryError");
        var ignoreCase = item.attr("data-ignoreCase") !== "true";

        // Get details on the fields we need to compare
        var fieldsToCompare = [];
        try {
          fieldsToCompare = JSON.parse(item.val());
        } catch (e) {
          // Nothing to do if we cannot read the list of fields to compare
        }

        if (fieldsToCompare.length > 0) {
          // Get a list of values for the list of fields
          var fieldValues = [];
          fieldsToCompare.forEach(function (field) {
            var fieldObj = $("#" + field + ", [name='" + field + "']");
            var fieldValue = "";
            if (fieldObj.length > 0) {
              fieldValue = ignoreCase ? fieldObj.val().toUpperCase() : fieldObj.val();
            }
            fieldValues.push(fieldValue);
          });

          // Make sure all field values are the same
          var groupValid = true;
          for (var index = 0; index < fieldValues.length; index++) {
            if (fieldValues[0] !== fieldValues[index]) {
              groupValid = false;
              break;
            }
          }

          if (!groupValid) {
            // Validation has failed for this group of fields, display the error message
            TECL_MandatoryFields.CreateErrorNode(mandatoryError, item, false, errorMessage);

            // Fail validation for the whole container
            containerValid = false;
          }
        }
      });
    }

    return containerValid;
  },

  // Validate fields to make sure they meet size requirements
  ValidateLength: function (container) {

    // Assume the container is valid
    var containerValid = true;

    // Get the template to use for mandatory field error messages
    var mandatoryError = $(TECL_MandatoryFields.MasterErrorTemplate);

    if (mandatoryError && mandatoryError.length > 0) {
      container.find("[data-mandatoryLength='true']").each(function () {

        var item = $(this);

        // Get error message and size limits
        var errorMessage = item.attr("data-mandatoryLengthError");
        var min = parseInt(item.attr("data-min"));
        var max = parseInt(item.attr("data-max"));

        // Check the "item" to see if it is the item that we need to test or whether it is linked to another item
        item = TECL_MandatoryFields.GetItemToValidate(item, container);

        if (item.length > 0) {
          // We have something to validate!
          var groupValid = true;
          item.each(function () {
            // We may have more than one item within the group to validate, so loop through each one and
            // validate it, for validation to pass at least one item must pass
            var value = $(this).val();
            if ((min !== 0) && (value.length < min)) {
              groupValid = false;
              return false;
            }
            if ((max !== 0) && (value.length > max)) {
              groupValid = false;
              return false;
            }
            return true;
          });

          if (!groupValid) {
            // Validation has failed for this group, display the error message
            TECL_MandatoryFields.CreateErrorNode(mandatoryError, item, true, errorMessage);

            // Fail validation for the whole container
            containerValid = false;
          }
        }
      });
    }

    return containerValid;
  },

  // Create a new error node and add it to the page
  CreateErrorNode: function (masterErrorNode, item, appendToParent, errorMessage) {

    var newError = masterErrorNode.clone();
    newError.html(errorMessage);
    newError.removeClass("hidden");
    newError.removeAttr("data-htmlTemplate");
    if (appendToParent) {
      newError.appendTo(item.parent());
    } else {
      newError.insertAfter(item);
    }

    // Store the validation error in the list of recent validation errors
    TECL_MandatoryFields.LastErrorsList.push(errorMessage);
  },

  /**
   * Toggle the highlight of an item on or off to indicate whether or not it has an error
   * @param {object} item The item to toggle the highlight on
   * @param {bool} state True: turn the highlight on, False: turn it off
   */
  ToggleHiglight: function (item, state) {

    // If this a Kendo Dropdown or a standard html control?
    var kendoItem = item.siblings(".k-dropdown-wrap").length !== 0;
    var itemToToggle = kendoItem ? item.siblings(".k-dropdown-wrap") : item;

    if (state) {
      itemToToggle.addClass("field-error-highlight");
    } else {
      itemToToggle.removeClass("field-error-highlight");
    }
  },

  // Get the item to validate, if the item is linked to another item (linked field) then we need to return the item it is linked too
  GetItemToValidate: function (item, container) {

    if (item.attr("data-linkedField") === "true") {
      // This is a linked field error so the item we are validating is not the item with the "data-MandatoryError" flag
      // against it. We need to try and find the actual item we are validating by ID, name or group
      var itemId = item.val();
      item = container.find("#" + itemId + ", [name='" + itemId + "'], [data-valGroup='" + itemId + "']");
    }

    return item;
  },

  // Display the summary message if validation has failed and the container has a summary message
  CreateSummary: function (isValid, container) {

    var summary = $("[data-mandatorySummary]");

    if (summary.length > 0 && container && container.length > 0) {

      var summaryMsg = container.attr("data-mandatorySummaryMsg");
      var summaryKey = container.attr("data-mandatorySummaryKey");

      // Remove any existing summary validation message for this container
      summary.children("[data-mandatorySummaryKey='" + summaryKey + "']").remove();

      if (summaryMsg && !isValid) {
        // If the container is not valid and we have a validation summary message to display, add the message
        // to the Mandatory Summary control
        summary.append(
          "<li class=\"mandatorySummaryItem\" data-mandatorySummaryKey=\"" +
          summaryKey +
          "\">" +
          summaryMsg +
          "</li>"
        );
      }
    }
  },

  // Reset the status of all mandatory fields within the container to thier default values
  ResetMandatoryFields: function (container) {

    if (!container) {
      container = $(document);
    } else {
      container = $(container);
    }

    container.find("[data-mandatoryFieldName]").each(function () {
      // Loop through every mandatory field and reset it to its default mandatory state
      var mandatory = this.getAttribute("data-mandatoryDefault");

      if (mandatory === null || mandatory === undefined) {
        mandatory = "false";
      }

      this.setAttribute("data-mandatoryField", mandatory);
    });
  },

  // Reset a specific controls mandatory field to its default state
  ResetMandatoryField: function (controlId, container) {

    if (container) {
      container = $(container);
    } else {
      container = $(document);
    }

    var control = container.find("#" + controlId + "[data-mandatoryField], [name='" + controlId + "'][data-mandatoryField],  [data-mandatoryField][value='" + controlId + "']");

    if (control.length > 0) {
      var mandatory = control.attr("data-mandatoryDefault");

      if (mandatory === null || mandatory === undefined) {
        mandatory = "false";
      }

      control.attr("data-mandatoryField", mandatory);
    }
  },

  // If we have any validation errors display them in a popup window
  ShowLastValidationErrors: function () {

    var valErrors = TECL_MandatoryFields.LastErrorsList;

    if (valErrors && valErrors.length > 0) {

      var valErrorList = $("#validationErrorsList");

      // Clear out existing errors
      valErrorList.empty();

      // Loop through the list of validation errors and add them to the list
      valErrors.forEach(function (valError) {
        valErrorList.append("<li>" + valError + "</li>");
      });

      $("#validationErrorDialog").modal("show");
    }
  },

  // Toggle the supplied controls mandatory status
  ToggleMandatoryField: function (controlId, mandatory, container) {

    if (!container) {
      container = $(document);
    } else {
      container = $(container);
    }

    var control = container.find("#" + controlId + "[data-mandatoryField], [name='" + controlId + "'][data-mandatoryField],  [data-mandatoryField][value='" + controlId + "']");

    if (control.length > 0) {
      if (mandatory) {
        control.attr("data-mandatoryField", "true");
      } else {
        control.attr("data-mandatoryField", "false");
      }
    }
  },

  // Toggle all of the controls in the supplied container
  ToggleMandatoryFields: function (container, mandatory) {

    var controls = $(container).find("[data-mandatoryField]");

    if (controls.length > 0) {
      if (mandatory) {
        controls.attr("data-mandatoryField", "true");
      } else {
        controls.attr("data-mandatoryField", "false");
      }
    }
  },

  // Check if the text is an email address
  ValidateEmailAddressText: function (emailAddressText) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,10})?$/;
    var isEmailAddress = emailReg.test(emailAddressText);
    return isEmailAddress;
  }
};